import { Box, Text } from '@wix/design-system';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

export const CONTEXTUAL_SUBTITLE_EXPERIMENT_KEY =
  'contextualSubtitlePurchaseFlow';

export interface StepSubtitleProps {
  /** Translation key for the step-specific subtitle. */
  textKey: string;
}

export const StepSubtitle = ({ textKey }: StepSubtitleProps) => {
  const { Trans } = EclipsePackagePickerModule.internals.useTranslations();

  return (
    <Box width="100%" align="center">
      <Text size="medium">
        <Trans i18nKey={textKey} />
      </Text>
    </Box>
  );
};
